export default __webpack_public_path__ + "static/media/logo-x.a0a1886a.png";